import {
  mergeSx,
  StatusChip,
  StatusChipProps,
  tokens,
} from '@cast/design-system';

type Props = {
  label?: string;
  size?: StatusChipProps['size'];
  className?: string;
  sx?: StatusChipProps['sx'];
};

export const ClusterDemoStatusChip = ({
  label,
  size,
  className,
  sx,
}: Props) => {
  return (
    <StatusChip
      className={className}
      size={size}
      sx={mergeSx(
        {
          backgroundColor: tokens.theme.bg.categorical.aquaSubtle,
          color: tokens.theme.fg.categorical.onAquaSubtle,
        },
        sx
      )}
    >
      {label || 'Demo'}
    </StatusChip>
  );
};

ClusterDemoStatusChip.displayName = 'DemoStatusChip';
